import getPriceByCoins from './getPriceByCoins';

const userLocale = navigator?.language || 'en-GB';

function getCurrencyPriceByCoins(coins = 0, currency, options) {
  const formatter = new Intl.NumberFormat(userLocale, {
    style: 'currency',
    currency,
    ...options,
  });

  const formattedPrice = formatter.format(getPriceByCoins(coins));

  return formattedPrice;
}

export default getCurrencyPriceByCoins;
